import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./PageStyles.css";

export default function About() {
  useEffect(() => {
    document.title = "About Us | Alpha APK Store™";

    let metaDescription = document.querySelector('meta[name="description"]');

    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }

    metaDescription.content =
      "Learn about Alpha APK Store™, your trusted platform for safe APK downloads, Android guides, Google login features, device compatibility checker, and APK tutorials.";
  }, []);

  return (
    <div className="static-page">
      <div className="static-card">
        <p className="about-tag">Trusted Android APK Platform</p>

        <h1>About Alpha APK Store™</h1>

        <p className="about-subtitle">
          Safe APK downloads, Android guides, smart device compatibility,
          optional Google login, app discovery, and mobile tools for users
          worldwide.
        </p>
      </div>

      <div className="about-stats">
        <div className="about-stat-card">
          <h2>49+</h2>
          <p>APK Listings</p>
        </div>

        <div className="about-stat-card">
          <h2>10+</h2>
          <p>Android Guides</p>
        </div>

        <div className="about-stat-card">
          <h2>Smart</h2>
          <p>Device Checker</p>
        </div>

        <div className="about-stat-card">
          <h2>2026</h2>
          <p>Updated Platform</p>
        </div>
      </div>

      <div className="static-card">
        <p>
          Welcome to <strong>Alpha APK Store™</strong>, a modern Android APK
          platform designed to help users discover Android apps, check APK
          details, explore compatibility, read Android guides, and access useful
          app information in a clean and mobile-friendly way.
        </p>

        <p>
          Our platform focuses on safe browsing, organized APK pages, helpful
          app information, screenshots, version details, FAQs, compatibility
          notes, and simple download guidance for Android users.
        </p>

        <h2>Our Mission</h2>

        <p>
         Alpha APK Store is an Android app discovery platform. We don't host APKs — we link to official sources like Google Play Store, GitHub, and F-Droid.
        </p>

        <p>
          We want to build a smarter APK platform where users can understand
          apps before downloading them, compare options, check Android
          compatibility, and discover useful alternatives.
        </p>

        <h2>Smart Platform Features</h2>

        <p>
          Alpha APK Store includes advanced features such as optional Google
          login, owner-secured admin access, Android device compatibility
          checking, APK detail analysis, SEO-friendly app pages, Android guides,
          and mobile-first browsing.
        </p>

        <p>
          These features help create a smarter and more personalized Android app
          discovery experience for users.
        </p>

        <h2>What We Provide</h2>

        <ul>
          <li>Safe APK browsing experience</li>
          <li>Android app information and guides</li>
          <li>Latest app versions and update details</li>
          <li>App screenshots and version information</li>
          <li>Optional Google login features</li>
          <li>Device compatibility checker</li>
          <li>iPhone and iOS APK warning system</li>
          <li>Mobile-friendly browsing experience</li>
          <li>Android tutorials and blog content</li>
          <li>FAQ sections for better user support</li>
          <li>Organized Android categories</li>
          <li>Fast and lightweight website experience</li>
        </ul>

        <h2>Why Users Choose Alpha APK Store</h2>

        <p>
          Android users prefer websites that are simple, lightweight,
          trustworthy, and optimized for mobile devices. Alpha APK Store focuses
          on creating exactly that type of experience.
        </p>

        <p>
          Users can browse APK categories, search apps, read Android guides,
          check compatibility, discover related apps, and explore detailed app
          pages without unnecessary clutter.
        </p>

        <h2>Security & Trust</h2>

           <p>
           Alpha APK Store operates on secure HTTPS infrastructure and maintains a clean public security reputation across independent website reputation systems.
          </p>

           <p>
           The domain currently shows no unsafe content detections across public security analysis platforms and follows secure browser delivery practices.
           </p>
      
        <p>
          APK files are only for Android devices. iPhone, iPad, and iOS devices
          cannot install APK files.
        </p>

        <h2>Content & Android Guides</h2>

        <p>
          Along with APK listings, Alpha APK Store publishes Android tutorials,
          safe APK download guides, music app recommendations, gaming articles,
          app comparisons, and Android tips.
        </p>

        <p>
          Our goal is to continuously expand Android-related educational content
          and improve the user experience.
        </p>

        <h2>Ownership</h2>

        <p>
          <strong>Owner: KARANDEEP SINGH SANDHU</strong>
        </p>

        <p>
          Alpha APK Store is independently owned, managed, and continuously
          developed with the goal of building one of the most unique Android APK
          discovery platforms.
        </p>

        <h2>Important Disclaimer</h2>

        <p>
          Alpha APK Store does not claim ownership of third-party applications,
          trademarks, logos, or brand names listed on the website. All rights
          belong to their respective owners.
        </p>

        <p>
          Our website focuses on providing Android app information, organized
          APK browsing, compatibility guidance, and educational Android content.
        </p>

        <h2>DMCA & Copyright</h2>

        <p>
          If you are a copyright owner and believe any content should be removed,
          please contact us through our support email. We take copyright
          concerns seriously and review requests carefully.
        </p>

        <h2>Contact & Support</h2>

        <p>
          For support, copyright concerns, broken links, app page issues, Google
          login issues, or general questions, contact:
        </p>

        <p>
          <strong>Email:</strong> alphaapkstore@gmail.com
        </p>

        <p>
          <strong>Official Website:</strong> https://www.alphaapkstore.com
        </p>

        <h2>Follow Alpha APK Store</h2>

        <div className="about-socials">
          <a
            href="https://www.youtube.com/@alphaapkstore"
            target="_blank"
            rel="noreferrer"
            title="Alpha APK Store YouTube"
          >
            ▶ YouTube
          </a>

          <a
            href="https://pin.it/4iXPuvWFH"
            target="_blank"
            rel="noreferrer"
            title="Alpha APK Store Pinterest"
          >
            📌 Pinterest
          </a>
        </div>

        <h2>Thank You</h2>

        <p>
          Thank you for visiting Alpha APK Store and supporting our growing
          Android platform. We are committed to improving the website experience
          and helping Android users discover useful applications and guides.
        </p>
      </div>
    </div>
  );
}